import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {screenSizeSmaller} from 'views/components';

import DesktopGuide from './DesktopGuide';
import MobileGuide from './MobileGuide';

const ClientProfile = (props) => {
  const setDrawerOpen = props.setDrawerOpen;

  const isMobile = screenSizeSmaller('md');

  return (
    <>
      {isMobile ? <MobileGuide setDrawerOpen={setDrawerOpen} /> : <DesktopGuide />}
    </>
  );
};

ClientProfile.propTypes = {
  setDrawerOpen: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  clientRn: state.user.clientRn,
});

export default connect(mapStateToProps, dispatch)(React.memo(ClientProfile));
